var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBitcoinCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bitcoin-cash_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 295.5 184.7",
    width: 2500,
    height: 1563
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bitcoin-cash_svg__st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bitcoin-cash_svg__Bitcoin_Cash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bitcoin-cash_svg__wordmark-bitcoincash-dark_min"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-229 -486)",
    id: "bitcoin-cash_svg__Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bitcoin-cash_svg__path0_fill",
    className: "bitcoin-cash_svg__st0",
    d: "M229 485.9h295.5v184.7H229V485.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-229 -486)",
    id: "bitcoin-cash_svg__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bitcoin-cash_svg__path1_fill",
    d: "M229 485.9h84.4c-14.7 10.4-26.6 24.2-34.9 40.3-8.3 16.1-12.6 33.9-12.6 52s4.3 36 12.6 52.1 20.2 29.9 34.9 40.3H229V485.9zm147.7 0c-24.1 0-47.2 9.7-64.3 27-17 17.3-26.6 40.8-26.6 65.3s9.6 48 26.6 65.3 40.2 27 64.3 27c24.1 0 47.2-9.7 64.3-27 17-17.3 26.6-40.8 26.6-65.3s-9.6-48-26.6-65.3c-17-17.3-40.2-27-64.3-27zm147.8 0h-84.4c14.7 10.4 26.6 24.2 34.9 40.3 8.3 16.1 12.6 33.9 12.6 52.1 0 18.1-4.3 36-12.6 52.1s-20.2 29.9-34.9 40.3h84.4V485.9z",
    fill: "#f7931a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-218.105 -482.324)",
    id: "bitcoin-cash_svg__Vector_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bitcoin-cash_svg__path2_fill",
    className: "bitcoin-cash_svg__st0",
    d: "M406 547.5c-4.1-11.7-15.3-13.1-28.4-11l-4.1-16.6-10 2.5 4 16.2c-2.6.7-5.3 1.4-7.9 2.1l-4-16.3-10 2.5 4.1 16.6c-2.1.6-4.3 1.2-6.3 1.7v-.1l-13.8 3.5 2.7 10.8s7.3-2 7.2-1.8c4-1 5.9 1 6.8 3l4.7 19c.4-.1.7-.2 1.1-.2l-1.1.3 6.5 26.6c.1 1.3-.1 3.6-2.9 4.3.2.1-7.3 1.8-7.3 1.8l1 12.6 13-3.3c2.4-.6 4.8-1.2 7.1-1.7l4.1 16.8 10-2.5-4.1-16.7c2.8-.6 5.4-1.3 8-1.9l4.1 16.6 10-2.5-4.1-16.8c16.5-5.2 27.2-12.5 24.7-28.9-2-13.2-9.4-17.4-19.5-17.3 5.1-4.5 7.4-10.7 4.4-19.3zm-5.1 39.5c3.1 12.6-18.5 16.5-25.2 18.2l-5.5-22.3c6.8-1.6 27.5-8.9 30.7 4.1zm-12.3-30.2c2.8 11.4-15.2 14.6-20.8 16l-5-20.2c5.6-1.5 22.8-7.8 25.8 4.2z"
  }))))));
}

export default SvgBitcoinCash;